<template>
    <nav class="top-level-menu">
        <ul class="menu">
            <li><router-link to="/performance">Performance</router-link></li>
            <li v-if="ascendMarketingEnabled"><router-link to="/ascend">Ascend</router-link></li>
            <li v-if="user && (user.company.hasFeature('Simulator') || user.internalUser)"><router-link to="/simulator">Simulator</router-link></li>
            <li v-if="user && (user.company.hasFeature('LenderUserGuide') || user.company.hasFeature('AggregatorUserGuide') || user.internalUser)"><router-link to="/user-guide">User Guide</router-link></li>
            <li><router-link to="/cookie-detail">Cookies</router-link></li>
        </ul>
    </nav>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'TopLevelMenu',
        computed: {
            ...mapGetters(['user','ascendMarketingEnabled'])
        }
    }
</script>

<style lang="scss" scoped>
    @use 'sass:math';
    @import '../styles/base';
    @import '../../node_modules/hd-styles/base';
    @import '../../node_modules/hd-styles/modules/mixins';

    $menu-height: $spacing-unit * 2;
    
    .top-level-menu {
        display: flex;
        align-items: center;
        padding: 0 $spacing-unit;
        justify-content: space-between;
        border-bottom: solid $border-width-light $grey;
    }

    ul {
        @include list-reset;
        @include rem(font-size, 14px);
        display: flex;
        gap: math.div($spacing-unit, 2);
    }

    a {
        height: $menu-height;
        line-height: $menu-height;
        color: $grey;
        text-decoration: none;
    }

    .menu {
        a {
            transform: translateY(1px);
            border-bottom: solid $border-width transparent;

            &.router-link-active {
                color: $blue;
                font-weight: 500;
                display: block;
                border-color: $blue;
            }
        }
    }
</style>
